import { render, staticRenderFns } from "./TextAutocompleteManuscript.vue?vue&type=template&id=048e926e&"
import script from "./TextAutocompleteManuscript.vue?vue&type=script&lang=js&"
export * from "./TextAutocompleteManuscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports